import { Layout, Text } from '@loadsmart/miranda-react'

import { type Carrier } from '../domain/Shipment'
import { formatCarrierInfo } from '../presenters/carrierInfoPresenter'

export type CarrierInfoProps = Readonly<{
  carrier: Carrier
}>

export function CarrierInfo({ carrier }: CarrierInfoProps) {
  return (
    <Layout.Stack gap="none" justify="flex-end" align="flex-end">
      <Text variant="body-md-bold">{carrier.name}</Text>
      <Text variant="body-sm">{formatCarrierInfo(carrier)}</Text>
    </Layout.Stack>
  )
}
